import ChangeBaseLineAPIServices from 'api/ChangeBaseLineAPIServices';
import { SearchParams } from 'api/ResourceAPI';
import useApi from 'hooks/useApi';
import { useCallback, useRef } from 'react';
import {
  injectDashboardOrdersAction,
  setDashboardOrderFilterAction,
  setKpiMetricGridDataAction,
} from 'store/actions/dashboardActions';
import { updateItemsFilterAction } from 'store/actions/filterActions';
import { useSelector } from 'store/hooks';
import { useAppState } from 'store/Provider';
import { SelectedFiltersList } from 'types/models/SelectedFiltersList';
import { addLoadingAction, removeLoadingAction } from 'store/actions/loadingsActions';
import Order from 'types/entities/Order';
import UserApiService from 'api/UserApiService';

export default function DashboardTabServices() {
  const { makeCall } = useApi();
  const { dispatch } = useAppState();

  const fetchDashboardTodoFilter = useCallback(async () => {
    try {
      const data = await makeCall(
        UserApiService.fetchDashboardFilterOrder(),
        'Unable to Dashboard Orders Filter',
        'Dashboard Todo Filter'
      );
      dispatch(
        setDashboardOrderFilterAction({
          data,
        })
      );
      return { data };
    } catch (error) {
      console.error('Failed to fetch Dashboard Orders Filter', error);
      // Return null to signal an error/no data fetched
      return null;
    }
  }, [makeCall]);

  const fetchDashboardTodoGrid = useCallback(
    async (searchParams: SearchParams) => {
      try {
        const data = await makeCall(
          UserApiService.fetchDashboardOrderGrid(searchParams),
          'Unable to Dashboard Orders',
          'Dashboard Todo Orders'
        );
        dispatch(
          injectDashboardOrdersAction({
            // Use destructuring to pull out the data and ensure correct keys
            dashboard_orders: data.dashboard_orders,
            totalItems: data.totalItems,
            totalPages: data.totalPage, // NOTE: Check capitalization here (API returns totalPage, action expects totalPages)
            currentPage: data.currentPage,
          })
        );
        return { data };
      } catch (error) {
        console.error('Failed to fetch Dashboard Orders Grid data ', error);
        // Return null to signal an error/no data fetched
        return null;
      }
    },
    [makeCall]
  );

  const getKpiMetricSuperFilter = useCallback(
    async (data_type: number, filterSelected: SelectedFiltersList) => {
      try {
        const response = await makeCall(
          UserApiService.fetchParamsFilterKpi(data_type, filterSelected),
          'Unable to Dashboard super Filter',
          'Dashboard Dashboard super Filter'
        );
        if (response && response['super-filters']) {
          dispatch(updateItemsFilterAction(response['super-filters']));
        }
        return response['super-filters'];
      } catch (error) {
        console.error('Failed to fetch Dashboard super Filter', error);
        // Return null to signal an error/no data fetched
        return null;
      }
    },
    [makeCall]
  );

  const fetchKpiMetricGraph = useCallback(
    async (data_type: number, filterSelected: SelectedFiltersList) => {
      try {
        const data = await makeCall(
          UserApiService.fetchKpiGraphData(data_type, filterSelected),
          'Unable to Dashboard Graph Data',
          'Dashboard Graph Data'
        );
        return data;
      } catch (error) {
        console.error('Failed to fetch Dashboard Graph Data', error);
        // Return null to signal an error/no data fetched
        return null;
      }
    },
    [makeCall]
  );

  const fetchKpiMetricGrid = useCallback(
    async (data_type: number, filterSelected: SelectedFiltersList) => {
      try {
        const data = await makeCall(
          UserApiService.fetchKpiGridData(data_type, filterSelected),
          'Unable to Dashboard Grid Data',
          'Dashboard Grid Data'
        );
        dispatch(
          setKpiMetricGridDataAction({
            // Use destructuring to pull out the data and ensure correct keys
            kpiMetricGridData: data?.orders?.datas,
            totalItems: data?.orders?.totalItems,
            totalPages: data?.orders?.totalPages, // NOTE: Check capitalization here (API returns totalPage, action expects totalPages)
            currentPage: data?.orders?.currentPage,
          })
        );

        return data;
      } catch (error) {
        console.error('Failed to fetch Dashboard Grid Data', error);
        // Return null to signal an error/no data fetched
        return null;
      }
    },
    [makeCall]
  );

  const downloadKpiGridExcel = useCallback(
    async (data_type: number, params: SearchParams) =>
      makeCall(UserApiService.getKpiExportExcel(data_type, params), 'Unable to export KPI Excel', 'export_kpi_excel'),
    [makeCall]
  );


  return {
    fetchDashboardTodoFilter,
    fetchDashboardTodoGrid,
    getKpiMetricSuperFilter,
    fetchKpiMetricGraph,
    fetchKpiMetricGrid,
    downloadKpiGridExcel,
  };
}
